<template>
  <v-card width="1024">
    <v-card-title>
      <v-container>
        <v-row class="headline">HawkSoft Seat Management</v-row>
        <v-row class="subtitle-2 font-italic">Customer ID: {{ agency.agencyId }}</v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <v-alert v-model="showAddSuccess" type="success" dense outlined prominent dismissible>You have submitted a request to add a user. You will receive an email within 1 business day once the change has been completed.</v-alert>
      <v-alert v-model="showDelSuccess" type="success" dense outlined prominent dismissible>You have submitted a request to remove a user. You will receive an email within 1 business day once the change has been completed.</v-alert>
      <v-alert v-model="showDelError" type="error" dense outlined prominent dismissible>Error sending seat change deletion request, please try again or contact customer support.</v-alert>
      <PendingSeatChangeRequests v-if="agencySeatRequests.length > 0" :headers="headers" :agency-seat-requests="agencySeatRequests" />
      <RemoteAgencySeatsTable v-if="!loading" :host-type="hostType" />
      <RemoteAgencyNewUserDialog :show-new-user-dialog="showNewUserDialogFlag" :host-type="hostType" @success="showAddUserSuccess" @close="showNewUserDialogFlag = false" />
    </v-card-text>
    <v-card-actions justify="end">
      <v-btn depressed tile color="#004C97" class="text-uppercase white--text" @click="openNewUserDialog()">Add New User</v-btn>
      <v-btn depressed tile @click="returnToMarketplace()">Cancel</v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import RemoteAgencySeatsTable from './RemoteAgencySeatsTable';
import RemoteAgencyNewUserDialog from './RemoteAgencyNewUserDialog';
import PendingSeatChangeRequests from './PendingSeatChangeRequests';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'RemoteAgencySeats',
  components: {
    RemoteAgencySeatsTable,
    RemoteAgencyNewUserDialog,
    PendingSeatChangeRequests
  },
  props: {
    hostType: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      showNewUserDialogFlag: false,
      showAddSuccess: false,
      agencySeatRequests: [],
      loading: true,
      headers: [
        { text: 'Requested By', value: 'requestedBy', class: 'caption font-weight-bold' },
        { text: 'Quantity', value: 'quantity', class: 'caption font-weight-bold' },
        { text: 'Name', value: 'name', class: 'caption font-weight-bold' },
        { text: 'Email', value: 'email', class: 'caption font-weight-bold' },
        { text: 'Status', value: 'status', class: 'caption font-weight-bold' },
        { text: 'Action', value: 'actions', class: 'caption font-weight-bold' }
      ]
    };
  },
  computed: {
    ...mapState(['seatManagementDeletionError', 'seatManagementDeletionSuccess', 'agency', 'remoteAgencySeats']),
    showDelError: {
      get: function () {
        return this.seatManagementDeletionError;
      },
      set: function () {
        this.setSeatChangeDeletionError(false);
      }
    },
    showDelSuccess: {
      get: function () {
        return this.seatManagementDeletionSuccess;
      },
      set: function () {
        this.resetSeatChangeDeletionSuccessState();
      }
    }
  },
  async created () {
    await this.getAgencySeatRequests();
  },
  beforeDestroy () {
    this.resetSeatChangeDeletionSuccessState();
  },
  methods: {
    ...mapActions(['resetSeatChangeDeletionSuccessState', 'setSeatChangeDeletionError', 'setPendingSeatManagementRequests', 'setRemoteAgencySeats', 'setRemoteAgencySeatDisplay']),
    returnToMarketplace () {
      this.$router.push('/marketplace');
    },
    openNewUserDialog () {
      this.showNewUserDialogFlag = true;
    },
    showAddUserSuccess (req) {
      this.agencySeatRequests.push(req);
      this.showAddSuccess = true;
    },
    async getAgencySeatRequests () {
      var resp = await this.$api.getAgencySeatRequests(this.agency.agencyId);
      if (resp.code === 0) {
        var payload = JSON.parse(resp.data[0]);
        this.agencySeatRequests = payload.data;
        this.removePendingDeletedUsers();
        this.setPendingSeatManagementRequests(this.agencySeatRequests);
        this.loading = false;
      } else if (resp.code > 2) {
        this.errorMessage = 'Error retrieving current seat change requests';
        this.loading = false;
      }
    },
    removePendingDeletedUsers () {
      // pull out the deletion requests so we don't have to iterate through each active request for each seat
      var delRequests = [];
      this.agencySeatRequests.forEach(req => {
        if (req.quantity === -1) {
          delRequests.push(req);
        }
      });

      // for each seat, look through each deletion request to see if there is an active request. Hide it if there is a match.
      this.remoteAgencySeats.forEach(seat => {
        for (let k = 0; k < delRequests.length; k++) {
          // unfortunately there is no ID on the seat as it is coming from the live DB
          if (seat.FirstName === delRequests[k].firstName && seat.LastName === delRequests[k].lastName && seat.Email === delRequests[k].email) {
            this.setRemoteAgencySeatDisplay(seat);
            break;
          }
        }
      });
    }
  }
};
</script>

<style scoped>

</style>
